import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "#fff",
  viewBox: "0 0 40 41"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M0 .422V40.74h40V.422zm33.333 4.48a2.23 2.23 0 0 1 2.223 2.24c0 1.236-.996 2.24-2.223 2.24a2.23 2.23 0 0 1-2.222-2.24c0-1.237.996-2.24 2.222-2.24M20 9.381c6.136 0 11.111 5.015 11.111 11.199s-4.975 11.2-11.111 11.2-11.111-5.016-11.111-11.2S13.864 9.381 20 9.381m0 4.48a6.64 6.64 0 0 0-4.714 1.967 6.75 6.75 0 0 0-1.953 4.752c0 1.782.703 3.491 1.953 4.752A6.64 6.64 0 0 0 20 27.3a6.64 6.64 0 0 0 4.714-1.968 6.75 6.75 0 0 0 1.953-4.752 6.75 6.75 0 0 0-1.953-4.752A6.64 6.64 0 0 0 20 13.861" }, null, -1)
  ])))
}
export default { render: render }